// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"appointment-page_rootContainer__2P_uz","gdprBloc":"appointment-page_gdprBloc__3LPmV"};